import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { SchemaOrganization, SchemaWebSite } from '@/components/feature/SchemaOrg';

export default function Layout() {
  return (
    <>
      <SchemaOrganization />
      <SchemaWebSite />
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}